import iconGoogle from "@assets/icon-google.png";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import useSendDataToGTM from "@features/analytics/hooks/useSendDataToGTM";
import { ArticleAllToolPopoverProps } from "@features/toolbar/ArticleToolbar/utils/types";
import { useWindowSize } from "@hooks/useWindowSize";
import { GOOGLE_PREFERED_SOURCES_LINK } from "@util/constant";
import { cn } from "@util/helpers";

/**
 * A React component that renders a Google Preferred Source Button on Article Toolbar
 */
const ArticleGooglePreferedSourceButton = ({
  className,
  articleUrl,
}: ArticleAllToolPopoverProps): React.ReactElement => {
  const sendDataToGTM = useSendDataToGTM();
  const { isScreenMD } = useWindowSize();

  const handleOnClick = () => {
    sendDataToGTM({
      event: "custom_event",
      eventCategory: "preferred source on google",
      eventAction: "click",
      eventLabel: articleUrl || "",
    });
  };

  return (
    <ButtonFactory
      buttonType={ButtonType.Link}
      mask={ButtonType.Secondary}
      testId="article-google-prefered-source-button"
      text="Add BT as a preferred source"
      onClick={handleOnClick}
      className={cn("inline-flex items-center gap-2", className)}
      link={GOOGLE_PREFERED_SOURCES_LINK}
      target="_blank"
      iconPosition="left"
      icon={
        <img
          width={isScreenMD ? 24 : 20}
          height={isScreenMD ? 24 : 20}
          alt="google-preferred-source"
          src={iconGoogle}
        />
      }
    />
  );
};

export default ArticleGooglePreferedSourceButton;
